/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-use-before-define */
/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import {
  IcoMoon,
  ChatWithUsWmoIcon,
  EmailUsWmoIcon,
  HelpCenterWmoIcon,
  EllipseWmoIcon,
  useResponsiveWrapperContext,
} from '@usap/uicomponents';
import {
  StyledButton,
  MaskedGroup,
  MaskedImage,
  StyledButtonContainer,
  StyledContactUsContainer,
  StyledHelpBox,
  StyledLinks,
  StyledQuestionContainer,
  StyledQuestionText,
  StyledButtonText,
} from './style/SupportBarTrackOrder.css';
import openChat from '@usap/carparts/src/shared/components/Kustomer/Events';
import { GTM, openSparkChatModal } from '@usap/carparts/src/shared/helpers';
import { useSparkChatEnabled } from '@usap/carparts/src/shared/hooks';

const SupportBarTrackOrder = ({
  isChatEnabled = false,
  isNotFound = false,
}) => {
  const { isDesktop } = useResponsiveWrapperContext();
  const isSparkChatEnabled = useSparkChatEnabled();

  const triggerEvent = (e) => {
    GTM.aiChatLinkClickGTM();
    if(isSparkChatEnabled) {
      e.preventDefault();
      openSparkChatModal();
    }
  }

  return (
    <StyledHelpBox>
      <StyledContactUsContainer gap="12px">
        <StyledQuestionContainer gap="12px">
          <MaskedGroup>
            <IcoMoon icon={EllipseWmoIcon} size={isDesktop ? '48px' : '40px'} />
            <MaskedImage isNotFound={isNotFound} />
          </MaskedGroup>
          <StyledQuestionText color="#282832" fontSize="18px" height="28px">
            Have a Question? We're Here to Help!
          </StyledQuestionText>
        </StyledQuestionContainer>
        <StyledButtonContainer gap="8px">
          {isChatEnabled ? (
            <StyledButton color="#FFCD05">
              <IcoMoon icon={ChatWithUsWmoIcon} />
              <StyledLinks color="#282832" href="/chat" onClick={triggerEvent}>
                Chat
              </StyledLinks>
            </StyledButton>
          ) : (
            <StyledButton color="#FFCD05" onClick={openChat}>
              <IcoMoon icon={ChatWithUsWmoIcon} />
              <StyledButtonText color="#282832">
                Chat
              </StyledButtonText>
            </StyledButton>
          )}
          <StyledButton color="#282832">
            <IcoMoon icon={EmailUsWmoIcon} />
            <StyledLinks
              color="#fff"
              href="/help-center/contact-us"
            >
              Email Us
            </StyledLinks>
          </StyledButton>
          <StyledButton color="#FFF" border="1px">
            <IcoMoon icon={HelpCenterWmoIcon} />
            <StyledLinks
              color="#3E3E47"
              href="/help-center"
              target='_self'
            >
              Help
            </StyledLinks>
          </StyledButton>
        </StyledButtonContainer>
      </StyledContactUsContainer>
    </StyledHelpBox>
  );
};

export default SupportBarTrackOrder;
